import { ORGANIZATION_ID_QUERY_PARAM } from './constants';

export const extractOrgIdFromQuery = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get(ORGANIZATION_ID_QUERY_PARAM);
};
